<template>
  <section class="copy-link">
    <ElTooltip
      v-model:visible="copied"
      trigger="manual"
      :content="message"
      :hide-after="1000"
      placement="right"
      :fallback-placements="['right', 'top']"
      popper-class="copy-link__popper"
    >
      <a
        class="copy-link__link"
        href="#"
        @click.prevent="copy"
      >{{ text }}</a>
    </ElTooltip>
  </section>
</template>

<script>
import ResponsiveMixin from '@/components/Helpers/responsive-mixin';
export default {
  mixins: [ResponsiveMixin],
  props: ['message', 'text'],
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    copy(ev) {
      const input = document.createElement('input');
      input.contentEditable = true;
      input.readOnly = true;
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.value = ev.target.innerText.trim();
      input.select();
      input.setSelectionRange(0, 99999);
      document.execCommand('copy');
      input.remove();
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
  .copy-link {
    &__hidden-input {
      opacity: 0;
      position: fixed;
      z-index: -1;
      right: 0px;
      bottom: -50px;
    }

    &__link {
      display: inline;
      color: var(--table-link-color);
      border-bottom-color: #00000000;
      border-bottom-style: dashed;
      border-bottom-width: 1px;

      &:hover {
        color: var(--table-link-color);
        border-bottom-color: var(--table-link-color);
        text-decoration: none;
      }
    }
    &__popper {
      font-size: 11px;
      font-weight: 600;
      line-height: normal;
      border-radius: 8px;
      background-color: rgba(48, 54, 52, 0.9);
      padding: 6px 8px;
    }
  }
</style>
